<p-dialog
  header="Dosya Yükleme"
  [(visible)]="displayUploadDialog"
  [modal]="true"
  [closable]="false"
  [style]="{ width: '35rem', 'max-height': '60vh', 'overflow-y': 'auto' }"
>
  <div class="modal-body">
    <form (ngSubmit)="save()" #fileUploadForm="ngForm">

      <!-- PREVIEW -->
      <div *ngIf="uploadedFile" class="mb-3 text-center">

        <!-- IMAGE -->
        <img
          *ngIf="filePreviewType === 'image'"
          [src]="filePreviewUrl"
          alt="preview"
          style="max-width: 100%; max-height: 250px; border-radius: 8px"
        />

        <!-- PDF -->
        <iframe
          *ngIf="filePreviewType === 'pdf'"
          [src]="filePreviewUrl"
          width="100%"
          height="300"
          style="border: 1px solid #ddd; border-radius: 8px"
        ></iframe>

        <!-- OTHER -->
        <div *ngIf="filePreviewType === 'other'" class="alert alert-info">
          {{ uploadedFile.fileName }} <br />
          <small>Bu dosya türü için önizleme yok</small>
        </div>

      </div>

      <!-- FILE INPUT -->
      <div class="row mb-3">
        <div class="col-12">
          <input
            #fileInput
            type="file"
            (change)="onFileChange($event)"
            class="form-control"
            required
          />
          <div *ngIf="fileError" class="text-danger mt-2">
            {{ fileError }}
          </div>
        </div>
      </div>

      <!-- DESCRIPTION -->
      <div class="row">
        <div class="col-12">
          <label class="form-label">
            {{ 'announcement.file-description' | translate }}
          </label>
          <input
            #selectedFileDesc
            type="text"
            class="form-control"
            [(ngModel)]="fileDescription"
            name="fileDescription"
            [placeholder]="'file.description-placeholder' | translate"
            required
          />
        </div>
      </div>

    </form>
  </div>

  <ng-template pTemplate="footer">
    <button
      type="button"
      class="btn btn-danger"
      style="margin-right: 3%"
      (click)="cancelDialog()"
    >
      {{ 'common.cancel' | translate }}
    </button>
    <button type="button" class="btn btn-success" (click)="save()">
      {{ 'common.save' | translate }}
    </button>
  </ng-template>
</p-dialog>
